import { render, staticRenderFns } from "./languages-buttons.vue?vue&type=template&id=15cd932e&"
import script from "./languages-buttons.vue?vue&type=script&lang=ts&"
export * from "./languages-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports